export class ApiEndPointsOrganization {
    // Summary
  // Call api to add organization
  addOrganization = 'api/Orgnization/AddOrganization';

  // Summary
  // Call api to get organizationlist
  getOrganization = 'api/Orgnization/GetOrganizationList';

  updateOrganization = 'api/Orgnization/UpdateOrganization';

  deleteOrganization = 'api/Orgnization/DeleteOrganization';

  getCountryList = 'api/Orgnization/GetCountryValues';

  getStateList = 'api/Orgnization/GetStateValues';

  getCityList = 'api/Orgnization/GetCityValues';

}
